import { SET_LOGIN, SET_USER } from './types'

export const setLogin = (payload) => ({
    type: SET_LOGIN, payload
})

export const setUser = (payload) => ({
    type: SET_USER, payload
})


// WEBPACK FOOTER //
// ./src/redux/login/actions.js